import { TeflLecComment } from '../../../lib/types/models/tefl-lec-comment/tefl-lec-comment'
import { TeflLecCommentInput } from '../../../lib/types/models/tefl-lec-comment/tefl-lec-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateTeflLecComment = async (
  data: UpdateInput<TeflLecCommentInput> & { teflId: number }
) => {
  const { id, teflId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.tefl.updateTeflLecComment.url, { id, teflId }))
    .patch<TeflLecComment, Partial<TeflLecCommentInput>>(rest)
}
